import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage author='Ryan Hill' dateTime='2022-03-02' tag='Memo' title='Ending our Small Seller Program'>
        <p>
          Hi everyone — my name is Ryan Hill and I run our Premium offering here at OneShop. A few months ago,{' '}
          <a href='https://tools.oneshop.com/company/memos/2021-12-19-small-seller-pricing-and-removing-weekly-billing'>
            I announced our Small Seller program.
          </a>{' '}
          This program was designed to offer small but growing sellers an affordable way to try OneShop as they became
          established sellers.
        </p>
        <p>
          What we’ve seen so far is that the program hasn’t been serving its purpose. Most of the eligible sellers
          aren’t looking to resell long term, and typically leave OneShop after doing a one time clear out of some
          items.
        </p>
        <p>
          By March 16, two weeks from now, we will no longer add anyone new to the Small Seller program. Existing
          sellers on the plan may continue until they are no longer eligible based on the original requirements.
        </p>
        <p>
          For any questions about billing in general, feel free to to reach out to our support team using any of the
          contact methods listed{' '}
          <a href='https://tools.oneshop.com/contact' target='_blank'>
            {' '}
            here.
          </a>
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
